import AppCalendarProviders from "./Providers";
import React from "react";
import AppCalendarContent from "./Content";
import AppCalendarModals from "./Modals";


// integerPrices: cell prices without decimals (Competition, Parity and Packages analyzers, CU-869fmuqwb).
// BI reuses the calendar and keeps the decimals (prop off by default).
export default function AppCalendar({ calendarData= {}, openDetailsModal = () => {}, externalEvents = [], dates = [], dateRange, startDate, showLocationData = false, integerPrices = false }) {

    return <AppCalendarProviders>
        <AppCalendarContent
            calendarData={calendarData}
            dateRange={dateRange}
            startDate={startDate}
            openDetailsModal={openDetailsModal}
            externalEvents={externalEvents}
            dates={dates}
            showLocationData={showLocationData}
            integerPrices={integerPrices}
        />
        <AppCalendarModals />
    </AppCalendarProviders>
}